import WithRender from "../../templates/buttons/applyDefaultSelection.html";
import { mapActions, mapGetters } from "vuex";
import { pathOr } from "ramda";

export default WithRender({
  computed: {
    ...mapGetters([
      "getOnCartSubmitCallback",
      "getChangeOptionsDataPPOpt",
      "getCimpressHiddenPageOptions",
      "getCimpressAttributeResolveStrategy"
    ])
  },
  methods: {
    onClick: function () {
      if (this.getOnCartSubmitCallback) {
        let printOptions = {};
        const postData = this.getChangeOptionsDataPPOpt;
        const optionsResolveStrategy = this.getCimpressAttributeResolveStrategy;
        for (const key in postData) {
          if (key.indexOf("PP_") !== -1) {
            const pp = key.replace("PP_", "");
            printOptions[pp] = {};
            const options = postData[key];
            for (const pageOptionKey in options) {
              const resolveStrategy = pathOr(
                null,
                [pp, pageOptionKey],
                optionsResolveStrategy
              );

              if ("quantity" === pageOptionKey.toLowerCase()) {
                continue;
              }
              const values = options[pageOptionKey].filter(val => val.length);
              if (values.length) {
                printOptions[pp][pageOptionKey] = {
                  isImplied: "implied" === resolveStrategy,
                  values
                };
              }
            }
          }
        }
        this.getOnCartSubmitCallback({
          printOptions,
          hiddenOptions: this.getCimpressHiddenPageOptions
        });
      }
    }
  }
});
